import { AlertCircle } from 'lucide-react'

import { Button } from '@/components/ui/button'

interface ForbiddenProps {
  error: string
  actionText?: string
  onAction?: () => void
  eventId?: string
}

const Forbidden = ({
  error,
  actionText,
  onAction,
  eventId,
}: ForbiddenProps) => {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center bg-white">
      <img
        src="/images/illustrations/not-authorized.svg"
        alt={error}
        className="w-[45%]"
      />
      <div className="flex items-center gap-4 text-fintalk">
        <AlertCircle size={24} />
        <span className="text-lg font-medium">{error}</span>
      </div>
      {eventId && (
        <span className="text-sm text-fintalk">Event ID: {eventId}</span>
      )}
      {onAction && (
        <Button variant="fintalk" className="mt-4" onClick={onAction}>
          {actionText}
        </Button>
      )}
    </div>
  )
}

export default Forbidden
